module.exports = __webpack_public_path__ + "img/17.66f5d024.png";